export default __webpack_public_path__ + "static/media/menu3_hl.b3356afe.png";